export const Config = {
  API_URL: "https://api.newroadargentina.com",
  PUSH_NOTIFICATIONS_PUBLIC_KEY:
    "BOTVGre4orxwruR3BbftlE2tQrDGzrMRuFOfqAzmFNQKrta45iN2SpE9Ma2A6JYHeMcLOzur640ViaZGZtygKw0",
  FIREBASE_CONFIG: {
    apiKey: "AIzaSyByEGKp7xI3PxGRhda16_SOC_5xLQ6xjw4",
    authDomain: "new-road-app.firebaseapp.com",
    databaseURL: "https://new-road-app.firebaseio.com",
    projectId: "new-road-app",
    storageBucket: "new-road-app.appspot.com",
    messagingSenderId: "734466128346",
    appId: "1:734466128346:web:f27152ce7eb1708cb928e3",
    measurementId: "G-EG2PTCG345",
  },
};



// WEBPACK FOOTER //
// ./src/Config/index.js